import { useQuery as i, useQueryClient as l, useMutation as y } from "@tanstack/react-query";
import n from "./notifications.api.js";
import { teachurKeys as s } from "../../constants/teachurKeys.js";
const f = (e) => ({
  notifications: e,
  unreadCount: e.filter((u) => !u.read).length
}), A = () => i({
  queryKey: s.notifications.list(),
  queryFn: async () => {
    const e = await n.getAll();
    return f(e.data);
  },
  refetchInterval: 10 * 1e3,
  // Default in v4 but set explicitly: pause polling while the tab is hidden.
  refetchIntervalInBackground: !1,
  // Treat the polling interval as the staleness window so focus-refetches
  // and remounts don't fire an extra request on top of each interval tick.
  staleTime: 10 * 1e3
}), Q = (e) => {
  const u = l();
  return y({
    mutationFn: async (r) => {
      const t = await n.markAsRead(r);
      return f(t.data);
    },
    onSuccess: (r, t, c) => {
      var a;
      u.setQueryData(s.notifications.list(), r), (a = e == null ? void 0 : e.onSuccess) == null || a.call(e, r, t, c);
    },
    onError: (r, t, c) => {
      var a;
      (a = e == null ? void 0 : e.onError) == null || a.call(e, r, t, c);
    },
    ...e
  });
};
export {
  A as useGetNotificationsQuery,
  Q as useMarkNotificationAsReadMutation
};
